module.exports = __webpack_public_path__ + "img/tank-f.837e990d.png";